import { ClockIcon } from '@heroicons/react/24/outline'
import type { Color } from 'stories/types'

import { ButtonGroup } from '../ButtonGroup/ButtonGroup'

interface ButtonGroupSelectorProps {
  /**
   * What background color to use
   */
  color?: Color
  /**
   * Is Full
   */
  full?: boolean
  /**
   * Is disabled
   */
  disabled?: boolean
  /**
   * Title of Input
   */
  title?: string
  /**
   * Name of Input
   */
  name?: string
  /**
   * Value of Input
   */
  value?: string
  /**
   * Error of Input
   */
  error?: string
  /**
   * Options of select
   */
  options: Array<string> | Record<string, string> // (Title => key)
  /**
   * Custom class name
   */
  className?: string
  /**
   * Required
   */
  required?: boolean
  /**
   * Show audit history icon
   */
  history?: boolean
  /**
   * Optional click handler
   */
  onChange?: (value: any) => void
  showHistory?: () => void
}

/**
 * Primary UI component for user interaction
 */
export const ButtonGroupSelector = ({
  disabled = false,
  title = '',
  value = '',
  error = '',
  options = [],
  className = '',
  required = false,
  history = false,
  onChange = () => {},
  showHistory = () => {},
}: ButtonGroupSelectorProps) => {
  const classNames = [
    'block',
    'rounded-xl',
    'px-2.5',
    'pb-[2px]',
    'pt-[27px]',
    'w-full',
    'text-[15px]',
    'text-gray-900',
    disabled ? 'bg-slate-100' : 'bg-white',
    'border',
    'border-slate-300',
    'focus:outline-none',
    'focus:ring-2',
    'focus:ring-shade-blue/20',
    'focus:bg-white',
    'transition',
    'hover:border-slate-400',
    'focus:border-shade-blue',
    'peer',
    error && 'border-rose-700',
  ]

  return (
    <div className="input-container">
      <div className={`group relative z-0 w-full group ${className}`}>
        <label className="absolute text-[12px] text-gray-700 top-1.5 z-10 origin-[0] left-2.5 flex gap-2 items-center">
          {title}
          {required && '*'}
          {history && (
            <span className="ml-1 hidden group-hover:inline" onClick={() => showHistory()}>
              <ClockIcon className="h-[14px] w-[14px] text-gray-600 cursor-pointer" aria-hidden="true" />
            </span>
          )}
        </label>
        <div className={classNames.join(' ')}>
          <ButtonGroup title={options} value={value} onChange={onChange} />
        </div>
      </div>
      {error && <p className="peer-invalid:visible text-rose-700 text-[13px] pt-[1px] pl-1">{error}</p>}
    </div>
  )
}
